export default "__VITE_ASSET__eJEp4i1F__"